import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ValidationMessageService} from '../../../../shared/services/validation-message-handle';
import {ToastrService} from 'ngx-toastr';
import {QuestionModel} from '../../../models/question.model';
import {AnswerChecboxModel, AnswerModel, AnswersTypeModel} from '../../../models/answer.model';

@Component({
  selector: 'show-question-row',
  templateUrl: './show-question-row.component.html',
  styleUrls: ['./show-question-row.component.scss']
})

export class ShowQuestionRowComponent implements OnInit {

  public loading = false;
  public questionForm: FormGroup;
  public answer: AnswerModel = null;

  @Input() question: QuestionModel;
  @Input() resultMode: boolean;
  @Output() updateQuestionEvent = new EventEmitter();


  constructor(
      private _formBuilder: FormBuilder,
      private validationMessageService: ValidationMessageService,
      private toastr: ToastrService
  ) {

  }

  ngOnInit(): void {

    this.questionForm = this._formBuilder.group({
      questionName: ['', Validators.required],
      answerType: ['', Validators.required],
      value: '',
    });


    if (this.resultMode) {
      this.questionForm.controls['value'].disable();
    }

    this.onFormChanges();

  }



  onFormChanges(): void
  {
    this.questionForm.valueChanges.subscribe(x => {
      this.question.answer.value = x.value;
      this.updateQuestionEvent.emit(this.question);
    });
  }
}

